import React, { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { useHideModal } from '../../actions/modal';
import { setOfp } from '../../actions/startInfo';
import { SignaturePopup } from '../../components/SignaturePopup/SignaturePopup';
import { checkCaptain } from '../../selectors/screen';
import { getCurrentSendedLeg } from '../../selectors/sended-data';

export const Signature = memo(
    forwardRef(({ ofpId }, ref) => {
        const hideModal = useHideModal();
        const dispatch = useDispatch();
        const { isCurrentUserCaptain, comment } = useSelector((state) => {
            const isCurrentUserCaptain = checkCaptain(state);
            const leg = getCurrentSendedLeg(state);
            const comment = leg && leg.signComment;

            return {
                comment,
                isCurrentUserCaptain,
            };
        }, shallowEqual);
        const { t: translate } = useTranslation();

        const handleSelectOfp = React.useCallback(
            (signature, comment) => {
                dispatch(setOfp(ofpId, signature, comment));
            },
            [ofpId]
        );

        const handleHideSignaturePopup = React.useCallback(() => {
            hideModal();
        }, []);

        return (
            <SignaturePopup
                ref={ref}
                visibility={true}
                text={translate('modal.signaturePopupText')}
                title={translate('modal.ofpSelectConfirm')}
                onSign={handleSelectOfp}
                onClose={handleHideSignaturePopup}
                signComment={comment}
                showComment={isCurrentUserCaptain}
                ofpId={ofpId}
            />
        );
    })
);
